import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import styles from './UserProfile.module.scss'
import Image from 'react-bootstrap/Image';
import { FaEdit } from "react-icons/fa";
import { UserEditProfile } from './UserEditProfile';
import { useDispatch, useSelector } from 'react-redux';
import { getStateSlice } from '../../../store/slices/state';
import { getCitySlice } from '../../../store/slices/citySlice';
import { getCountrySlice } from '../../../store/slices/countrySlice';
import { getUserInfo, updateUserDetails } from '../../../store/slices/authSlice';
import { resetUpdateMessage } from '../../../store/slices/authSlice';
import userImage from '../../../images/userImage.avif'
import {
    showToastifySuccess,
    showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
const UserProfile = () => {
    const dispatch = useDispatch();
    const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
    const { userInfo, updateErrorMessage, updateSuccessMessage, token } = useSelector((state) => state.auth);
    const { cities } = useSelector((state) => state.city);
    const { Country } = useSelector((state) => state.country);
    const { state } = useSelector((state) => state.state);
    const Genderoptions = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
        { value: "Other", label: "Other" },
    ];
    const [modalshow, setModalShow] = useState(false);
    const [userData, setUserData] = useState({
        name: "",
        email: "",
        phone: "",
        gender: "",
        age: {
            year: null,
            month: null,
            day: null,
        },
        dob: "",
        aadhar_number: "",
        alternate_Phone: "",
        profilePic: null,
        address: {
            area: "",
            city: "",
            cityName: "",
            country: "",
            countryName: "",
            state: "",
            stateName: "",
            street: "",
            plot: "",
            landMark: "",
            pin: "",
        },
    })
    const [inputError, setInputError] = useState({
        name: false,
        email: false,
        phNumber: false,
        pinCode: false,
        aadhar: false,
        image: false,
    });

    useEffect(() => {
        dispatch(getCountrySlice({ token }));
    }, [dispatch, token]);

    useEffect(() => {
        showTostifyMessageAndReset(
            updateSuccessMessage,
            showToastifySuccess,
            resetUpdateMessage
        );
        showTostifyMessageAndReset(
            updateErrorMessage,
            showToastifyError,
            resetUpdateMessage
        );
    }, [
        dispatch,
        updateSuccessMessage,
        updateErrorMessage,
        showTostifyMessageAndReset,
    ]);
    const handleInputChange = (e) => {
        if (e.dob && e.age) {
            setUserData((prev) => ({
                ...prev,
                dob: e.dob,
                age: e.age,
            }));
        } else {
            const { name, value } = e.target;
            if (
                name === "name" ||
                name === "phone" ||
                name === "email" ||
                name === "aadhar_number" ||
                name === "alternate_Phone"
            ) {
                setUserData((prevData) => ({
                    ...prevData,
                    [name]: value,
                }));
            } else {
                setUserData((prevData) => ({
                    ...prevData,
                    address: {
                        ...prevData.address,
                        [name]: value,
                    },
                }));
            }
        }
    };

    const handleImageUpload = (file) => {
        if (file) {
            setUserData((prevData) => ({
                ...prevData,
                profilePic: file,
            }));
        }
    };
    const handleSelectChange = async (selectedOption, name) => {
        if (name === "city") {
            setUserData((prevData) => ({
                ...prevData,
                address: {
                    ...prevData.address,
                    city: selectedOption.value,
                    cityName: selectedOption.label,
                },
            }));
        } else if (name === "country") {
            setUserData((prevData) => ({
                ...prevData,
                address: {
                    ...prevData.address,
                    country: selectedOption.value,
                    countryName: selectedOption.label,
                },
            }));
            await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
        } else if (name === "state") {
            setUserData((prevData) => ({
                ...prevData,
                address: {
                    ...prevData.address,
                    state: selectedOption.value,
                    stateName: selectedOption.label,
                },
            }));
            await dispatch(
                getCitySlice({
                    countryId: userData.address.country,
                    stateId: selectedOption.value,
                    token
                })
            );
        } else if (name === "gender") {
            setUserData((prevData) => ({
                ...prevData,
                gender: selectedOption.value,
            }));
        }
    };

    const handleEdit = (item) => {
        try {
            setModalShow(true);
            setUserData({
                name: item?.name || "",
                phone: item?.phone || "",
                email: item?.email || "",
                alternate_Phone: item?.alternate_Phone || "",
                gender: item?.gender || "",
                age: item?.age || "",
                dob: item?.dob ? new Date(item?.dob).toISOString().split("T")[0] : "",
                aadhar_number: item?.aadhar_number || "",
                address: {
                    area: item?.address?.area || "",
                    city: item?.address?.city?._id || "",
                    cityName: item?.address?.city?.name || "",
                    country: item?.address?.country?._id || "",
                    countryName: item?.address?.country?.name || "",
                    state: item?.address?.state?._id || "",
                    stateName: item?.address?.state?.name || "",
                    street: item?.address?.street || "",
                    plot: item?.address?.plot || "",
                    landMark: item?.address?.landMark || "",
                    pin: item?.address?.pin || "",
                },
            });
        } catch (error) {
            console.error("Error in handleEdit:", error);
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        const { name, email, phNumber, aadhar, pinCode, image
        } = inputError;
        if (name || email || phNumber || aadhar || pinCode || image) {
            return;
        }
        try {
            const formData = new FormData();
            formData.append("id", userInfo?._id);
            formData.append("profilePic", userData?.profilePic);
            formData.append("name", userData?.name);
            formData.append("phone", userData?.phone);
            formData.append("alternate_Phone", userData?.alternate_Phone);
            formData.append("email", userData?.email);
            formData.append("aadhar_number", userData?.aadhar_number);
            formData.append("gender", userData?.gender);
            formData.append("year", userData?.age.year || 0);
            formData.append("month", userData?.age.month || 0);
            formData.append("day", userData?.age.day || 0);
            formData.append("dob", userData?.dob);
            formData.append("area", userData?.address?.area);
            formData.append("street", userData?.address?.street);
            formData.append("plot", userData?.address?.plot);
            formData.append("landMark", userData?.address?.landMark);
            formData.append("pin", userData?.address?.pin);
            formData.append("country", userData?.address?.country);
            formData.append("state", userData?.address?.state);
            formData.append("city", userData?.address?.city);
            await dispatch(updateUserDetails({ formData, token })).then(() => {
                setModalShow(false);
                dispatch(getUserInfo({ userId: userInfo?._id, token }));
            });
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <>
            <div className={styles.profilebackground}></div>
            <Container className={styles.profilecontainer}>
                <Row className={styles.profilerow}>
                    <Col lg={12} md={12} sm={12} xs={12} className={styles.profilecol}>
                        <div className={styles.profilediv}>
                            <div className={styles.profileimg}>
                                <div className={styles.profileimage}>
                                    <p>Connect</p>
                                    {userInfo?.profilePic ? <div className={styles.profileimgdiv}>
                                        <Image src={userInfo?.profilePic} alt="userImage" />
                                    </div> : <div className={styles.profileimgdiv}>
                                        <Image src={userImage} alt="userImage" />
                                    </div>
                                    }
                                    <div className={styles.profileedit}>
                                        <FaEdit onClick={() => handleEdit(userInfo)} />
                                    </div>
                                </div>
                                <div className={styles.profileinfoInner}>
                                    <h3>{userInfo?.name}</h3>
                                    <p> {userInfo?.address ? (
                                        <>
                                            {userInfo.address.plot &&
                                                `${userInfo.address.plot}, `}
                                            {userInfo.address.area &&
                                                `${userInfo.address.area}, `}
                                            {userInfo.address.street &&
                                                `${userInfo.address.street}, `}
                                            {userInfo.address.landMark &&
                                                `${userInfo.address.landMark}, `}
                                            {userInfo.address.city?.name &&
                                                `${userInfo.address.city.name}, `}
                                            {userInfo?.address?.state?.name &&
                                                `${userInfo.address.state.name}, `}
                                            {userInfo.address.country?.name &&
                                                `${userInfo.address.country.name}, `}
                                            {userInfo.address.pin && userInfo.address.pin}
                                        </>
                                    ) : (
                                        "N/A"
                                    )}</p>
                                </div>
                            </div>
                            <div className={styles.profileinfo}>
                                <ul>
                                    <li><span className={styles.profilespan}>Email:</span><span className={styles.profileText}>{userInfo?.email}</span></li>
                                    <li><span className={styles.profilespan}>Number:</span><span className={styles.profileText}>{userInfo?.phone}</span></li>
                                    <li><span className={styles.profilespan}>Age:</span><span className={styles.profileText}>  {userInfo?.age?.year ? `${userInfo?.age?.year} Y` : "0 Y"} {userInfo?.age?.month ? `${userInfo?.age?.month} M` : "0 M"} {userInfo?.age?.day ? `${userInfo?.age?.day} D` : "0 D"}</span></li>
                                    <li><span className={styles.profilespan}>Gender:</span><span className={styles.profileText}>{userInfo?.gender || "NA"}</span></li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <UserEditProfile
                modalshow={modalshow}
                setModalShow={setModalShow}
                handleEdit={handleEdit}
                userData={userData}
                setUserData={setUserData}
                handleSelectChange={handleSelectChange}
                state={state}
                cities={cities}
                Country={Country}
                handleImageUpload={handleImageUpload}
                handleInputChange={handleInputChange}
                genderOptions={Genderoptions}
                handleUpdate={handleUpdate}
                setInputError={setInputError}
            />
        </>
    )
}

export default UserProfile